document.addEventListener("turbo:load", function() {
  const checkboxes = document.querySelectorAll("[data-js-id=js-industry-filter-checkbox")
  const form = document.querySelector("[data-js-id=js-industry-filter-form")
  const cityField = document.querySelector("[data-js-id=js-job-city-field")
  const termField = document.querySelector("[data-js-id=js-job-term-field")

  for (let i = 0; i < checkboxes.length; i++) {
    checkboxes[i].addEventListener("change", function(event) {
      if (termField.value === "" || cityField.value === "") {
        event.preventDefault();
        form.reportValidity();
      } else {
        form.submit();
      }
    });
  }
});
